import { SecuredKoppClient } from "Core/Api/Kopp/SecuredKoppClient";
import { GetFilteredTrackedBolFileTypeForLoggedInUserQueryRequest, OrderBy, UpdateTrackedBolSupplementaryInfoRequestModel } from "Core/Api/Kopp/Api";


export class TrackedBolSupplementaryInfoFormHandler {
    props: any;
    constructor(props) {
        this.props = props;
    }

    GetTrackedBolDesciptions() {
        const client = new SecuredKoppClient();
        const request = new GetFilteredTrackedBolFileTypeForLoggedInUserQueryRequest();
        request.amountPerPage = 200;
        client.showLoading = true;
        client.handleGeneralError = true;
        request.orderBy = request.orderBy ?? [];
        request.orderBy.push(new OrderBy({ ascending: true, field: "Name" }));
        return client.getFilteredTrackedBolDescriptionForLoggedUser(request);
    }

    UpdateTrackedBolSupplementaryInfo(request: UpdateTrackedBolSupplementaryInfoRequestModel) {
        let client = new SecuredKoppClient();
        client.showLoading = true;
        client.handleGeneralError = true;

        return client.updateTrackedBolSupplementaryInfo(request);
    }

    GetBolFileTypes() {
        const client = new SecuredKoppClient();
        const request = new GetFilteredTrackedBolFileTypeForLoggedInUserQueryRequest();
        request.amountPerPage = 200;
        client.showLoading = true;
        client.handleGeneralError = true;
        return client.getFilteredTrackedBolFileTypeForLoggedInUser(request);
    }
}
